module.exports = __webpack_public_path__ + "img/trine-beder-john-5.55550b92.png";